import { combineReducers } from "redux";
import androidReducer from "./android/android.reducer";
import appVMReducer from "./app/app.reducer";
import billReducer from "./bill/bill.reducer";
import cartReducer from "./cart/cart.reducer";
import cashLeftOverReducer from "./cashLeftOver/cashLeftOver.reducer";
import commonReducer from "./common/common.reducer";
import customerCareReducer from "./customerCare/customerCare.reducer";
import gameReducer from "./game/game.reducer";
import productReducer from "./product/product.reducer";
import topupReducer from "./topup/topup.reducer";
import transTopupBankReducer from "./transTopupBank/transTopupBank.reducer";
import vendingMachineReducer from "./vendingmachine/vendingmachine.reducer";

const appReducer = combineReducers({
  commonReducer: commonReducer,
  cartReducer: cartReducer,
  vendingMachineReducer: vendingMachineReducer,
  productReducer: productReducer,
  billReducer: billReducer,
  gameReducer: gameReducer,
  appVMReducer: appVMReducer,
  customerCareReducer: customerCareReducer,
  androidReducer: androidReducer,
  cashLeftOverReducer: cashLeftOverReducer,
  transTopupBankReducer: transTopupBankReducer,
  topupReducer: topupReducer
});
export type RootState = ReturnType<typeof appReducer>;
export type FGetState = () => RootState;
export default appReducer;
